module.exports = __webpack_public_path__ + "media/start.8f93ca98.mp3";